import { useCartStore } from '../store/cart-store';

interface CartSidebarProps {
  onPay: () => void;
}

export function CartSidebar({ onPay }: CartSidebarProps) {
  const items = useCartStore((s) => s.items);
  const updateQuantity = useCartStore((s) => s.updateQuantity);
  const getTotal = useCartStore((s) => s.getTotal);
  const getItemCount = useCartStore((s) => s.getItemCount);

  const cartItems = Object.values(items);
  const total = getTotal();
  const itemCount = getItemCount();

  const formattedTotal = total.toFixed(2).replace('.', ',');

  return (
    <div className="flex flex-col h-full bg-surface-card rounded-2xl overflow-hidden">
      {/* Header */}
      <div className="flex items-center gap-3 px-5 py-4 border-b border-white/10">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-white shrink-0">
          <path
            d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM7.16 14.26l.04-.12.94-1.7h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0020.04 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7.42a.25.25 0 01-.26-.24z"
            fill="currentColor"
          />
        </svg>
        <h2 className="text-xl font-bold text-white">Panier</h2>
        {itemCount > 0 && (
          <span className="bg-accent rounded-full min-w-[28px] h-7 flex items-center justify-center text-white text-sm font-bold px-2">
            {itemCount}
          </span>
        )}
      </div>

      {/* Cart items */}
      <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
        {cartItems.length === 0 && (
          <p className="text-white/40 text-center mt-8">Panier vide</p>
        )}
        {cartItems.map((item) => {
          const subtotal = (item.price * item.quantity).toFixed(2).replace('.', ',');
          const unitPrice = item.price.toFixed(2).replace('.', ',');

          return (
            <div key={item.key} className="bg-surface-light rounded-xl p-3">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1 min-w-0 mr-2">
                  <p className="text-white font-medium truncate">{item.name}</p>
                  <p className="text-white/50 text-sm">{unitPrice}&nbsp;&euro;/u</p>
                </div>
                <p className="text-white font-bold text-lg shrink-0">
                  {subtotal}&nbsp;&euro;
                </p>
              </div>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className="min-w-[44px] min-h-[44px] bg-surface-card rounded-lg flex items-center justify-center text-white text-xl font-bold active:scale-95 transition-transform"
                  onClick={() => updateQuantity(item.key, item.quantity - 1)}
                >
                  &minus;
                </button>
                <span className="text-white font-bold text-lg min-w-[32px] text-center">
                  {item.quantity}
                </span>
                <button
                  type="button"
                  className="min-w-[44px] min-h-[44px] bg-surface-card rounded-lg flex items-center justify-center text-white text-xl font-bold active:scale-95 transition-transform"
                  onClick={() => updateQuantity(item.key, item.quantity + 1)}
                >
                  +
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="px-5 pb-5 pt-3 border-t border-white/10 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-white/70 text-lg">Total</span>
          <span className="text-3xl font-bold text-white">{formattedTotal}&nbsp;&euro;</span>
        </div>
        <button
          type="button"
          className="btn-primary w-full text-center text-xl tracking-wide disabled:opacity-40 disabled:cursor-not-allowed"
          disabled={itemCount === 0}
          onClick={onPay}
        >
          PAYER
        </button>
      </div>
    </div>
  );
}
